import {AddressModel} from './address.model';
export class CompanyModel {
    active?: any = null;
    name?: any = null;
    socialMediaUrl?: any = null;
    uid?: any = null;
    website?: any = null;
    addresses?: AddressModel[] = [];
    constructor(Company) {
        {
            if (Company){
                this.active = Company.active || '';
                this.name = Company.name || '';
                this.socialMediaUrl = Company.socialMediaUrl || '';
                this.uid = Company.uid || '';
                this.website = Company.website || '';
                if (Company.addresses){
                    this.addresses.push(new AddressModel(Company.addresses[0]));
                }else{
                    this.addresses.push(new AddressModel(Company.addresses));
                }

            }

        }
    }
}